import React, { useState, useEffect } from "react";
import "./dashboard.css";
import Form from "react-bootstrap/Form";
import InputGroup from "react-bootstrap/InputGroup";
import axios from "axios";
import Navb from "../../components/navbar/Navb";
// import Arrow from "./arrow.svg";
import SideBar from "./SideBar";
import API_URL from "../../constants";
// const [submit, setSubmit] = useState(false);
//   const [candidate, setCandidate] = useState([]);
// const Dashboard = () => {
//   const [jobs, setJobs] = useState([]);
//   const [jobsId, setJobsId] = useState();
//   const [editingJobId, setEditingJobId] = useState(null);
const Createjob = () => {
  const [formData, setFormData] = useState({
    company_name: "",
    job_description: "",
    skills: "",
    openings: "",
    salary_offered: "",
    post: "",
    location: "",
    remote: "",
    years_of_experience: "",
    keywords: [],
    status: "",
  });
  const [addnewskill, setAddnewskill] = useState(false);
  const [selectedSkills, setSelectedSkills] = useState([]);
  const [clickedSkills, setClickedSkills] = useState([]);
  const [addnewkeyword, setAddnewkeyword] = useState(false);
  const [selectedKeywords, setSelectedKeywords] = useState([]);
  const [clickedKeywords, setClickedKeywords] = useState([]);
  const handleCreateSubmit = async (e) => {
    e.preventDefault();
    console.log("submitformData", formData);
    const { skills, keywords, ...formDataWithoutTimestamps } = formData;
    const dataToChange = {
      ...formDataWithoutTimestamps,
      skills: clickedSkills,
      keywords: clickedKeywords,
    };
    console.log("submitdataToChange", dataToChange);
    try {
      const response = await axios.post(
        `${API_URL}/admin/create_jobs`,
        dataToChange
      );
      console.log("Job created successfully:", response.data);
      // Optionally, you can reset the form after submission
      setFormData({
        company_name: "",
        job_description: "",
        location: "",
        openings: "",
        post: "",
        remote: "",
        salary_offered: "",
        skills: "",
        years_of_experience: "",
        keywords: [],
        status: "",
      });
    } catch (error) {
      console.error("Error creating job:", error);
    }
  };
  const handleCreateChange = (e) => {
    const { name, value } = e.target;
    if (name === "keywords") {
      const keywordsArray = value
        .split(/[, ]+/)
        .map((keyword) => keyword.trim());
      setFormData({ ...formData, [name]: keywordsArray });
    } else if (name === "skills") {
      const skillsArray = value.split(/[, ]+/).map((skill) => skill.trim());
      setFormData({ ...formData, [name]: skillsArray });
    } else {
      setFormData({ ...formData, [name]: value });
    }
    console.log("formData", formData);
  };
  const fetchkeywordToken = async () => {
    try {
      // const url = window.location.href;
      // const id = url.substring(url.lastIndexOf("/") + 1);
      const response = await axios.get(`${API_URL}/admin/get_token`, {
        params: { type: "keywords" },
      });
      console.log("response", response);

      // Update selected skills with the skills received
      setSelectedKeywords(response.data.tokens);
      console.log("selectedKeywords", selectedKeywords);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  useEffect(() => {
    fetchkeywordToken();
  }, []);
  const handleKeywordClick = (event, keyword) => {
    event.preventDefault(); // Prevent form submission
    console.log("ClickedKeywordstop", clickedKeywords);
    // Check if the skill is already in the clickedSkills array
    const isKeywordClicked = clickedKeywords.includes(keyword);

    if (isKeywordClicked) {
      // If the skill is already clicked, remove it from the clickedSkills array
      setClickedKeywords(clickedKeywords.filter((s) => s !== keyword));
    } else {
      // If the skill is not clicked, add it to the clickedSkills array
      setClickedKeywords([...clickedKeywords, keyword]);
    }
    console.log("ClickedKeywords1", clickedKeywords);
  };
  useEffect(() => {
    console.log("ClickedKeywords", clickedKeywords);
  }, [clickedKeywords]);
  const handleKeywordPostData = async (event) => {
    event.preventDefault(); // Prevent the default form action
    console.log("keyworddata", formData.keywords);
    try {
      const sendData = {
        type: "keywords",
        tokens: formData.keywords,
      };
      const response = await axios.post(
        `${API_URL}/admin/add_token`,
        sendData
      );
      console.log("response", response);
      fetchkeywordToken();
    } catch (error) {
      console.log(error);
    }
  };
  const fetchToken = async () => {
    try {
      const url = window.location.href;
      const id = url.substring(url.lastIndexOf("/") + 1);
      const response = await axios.get(
        `${API_URL}/admin/get_token`,
        {
          params: { type: "skills" },
        }
      );
      console.log("response", response);

      // Update selected skills with the skills received
      setSelectedSkills(response.data.tokens);
      console.log("selectedSkills", selectedSkills);
    } catch (error) {
      console.error("Error:", error);
    }
  };
  useEffect(() => {
    fetchToken();
  }, []);
  const handleSkillClick = (event, skill) => {
    event.preventDefault(); // Prevent form submission
    console.log("ClickedSkillstop", clickedSkills);
    // Check if the skill is already in the clickedSkills array
    const isSkillClicked = clickedSkills.includes(skill);

    if (isSkillClicked) {
      // If the skill is already clicked, remove it from the clickedSkills array
      setClickedSkills(clickedSkills.filter((s) => s !== skill));
    } else {
      // If the skill is not clicked, add it to the clickedSkills array
      setClickedSkills([...clickedSkills, skill]);
    }
    console.log("ClickedSkills1", clickedSkills);
  };
  useEffect(() => {
    console.log("ClickedSkills", clickedSkills);
  }, [clickedSkills]);
  const handleSkillPostData = async (event) => {
    event.preventDefault(); // Prevent the default form action
    console.log("skilldata", formData.skills);
    try {
      const sendData = {
        type: "skills",
        tokens: formData.skills,
      };
      const response = await axios.post(
        `${API_URL}/admin/add_token`,
        sendData
      );
      console.log("response", response);
      fetchToken();
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <Navb />
      <div className="dashboard">
        <SideBar />
        <section className="rightBar">
          <div className="jobItem">
            <div className="jobActions">
              <Form onSubmit={handleCreateSubmit}>
                <div className="allInputField">
                  <InputGroup className="mb-3">
                    <div className="wrapper_input">
                      <div className="jobTitle">Company Name: </div>

                      <Form.Control
                        className="inputField"
                        placeholder="company_name"
                        aria-label="name"
                        aria-describedby="basic-addon1"
                        type="text"
                        name="company_name"
                        value={formData.company_name || ""}
                        onChange={handleCreateChange}
                        required
                      />
                    </div>

                    <div className="wrapper_input">
                      <div className="jobTitle">Location: </div>
                      <Form.Control
                        className="inputField"
                        placeholder="location"
                        aria-label="name"
                        aria-describedby="basic-addon1"
                        type="text"
                        name="location"
                        value={formData.location || ""}
                        onChange={handleCreateChange}
                        required
                      />
                    </div>
                    <div className="wrapper_input">
                      <div className="jobTitle">Openings: </div>
                      <Form.Control
                        className="inputField"
                        placeholder="openings"
                        aria-label="name"
                        aria-describedby="basic-addon1"
                        type="text"
                        name="openings"
                        value={formData.openings || ""}
                        onChange={handleCreateChange}
                        required
                      />
                    </div>
                    <div className="wrapper_input">
                      <div className="jobTitle">Post: </div>
                      <Form.Control
                        className="inputField"
                        placeholder="post"
                        aria-label="name"
                        aria-describedby="basic-addon1"
                        type="text"
                        name="post"
                        value={formData.post || ""}
                        onChange={handleCreateChange}
                        required
                      />
                    </div>
                    <div className="wrapper_input">
                      <div className="jobTitle">Mode of Work: </div>
                      <Form.Select
                        className="inputField"
                        aria-label="Mode of Work"
                        aria-describedby="basic-addon1"
                        name="remote"
                        value={formData.remote || ""}
                        onChange={handleCreateChange}
                        required
                      >
                        <option value="">Select mode of work</option>
                        <option value="remote">Remote</option>
                        <option value="hybrid">Hybrid</option>
                        <option value="onsite">Onsite</option>
                      </Form.Select>
                    </div>
                    <div className="wrapper_input">
                      <div className="jobTitle">Salary Offered: </div>
                      <Form.Control
                        className="inputField"
                        placeholder="salary_offered"
                        aria-label="name"
                        aria-describedby="basic-addon1"
                        type="text"
                        name="salary_offered"
                        value={formData.salary_offered || ""}
                        onChange={handleCreateChange}
                        required
                      />
                    </div>
                    {/* <div className="wrapper_input">
                      <div className="jobTitle">Skills: </div>
                      <Form.Control
                        className="inputField"
                        placeholder="skills"
                        aria-label="name"
                        aria-describedby="basic-addon1"
                        type="text"
                        name="skills"
                        value={formData.skills || ""}
                        onChange={handleCreateChange}
                        required
                      />
                    </div> */}
                    <div className="wrapper_input">
                      <div className="jobTitle">Keywords: </div>
                      <div id="skill-container">
                        {selectedKeywords.map((keyword) => (
                          <button
                            key={keyword}
                            className={
                              clickedKeywords.includes(keyword)
                                ? "highlighted"
                                : "nothighlighted"
                            }
                            onClick={(event) =>
                              handleKeywordClick(event, keyword)
                            }
                          >
                            {keyword}
                          </button>
                        ))}
                      </div>
                      {addnewkeyword && (
                        <>
                          <Form.Control
                            className="inputField"
                            // placeholder={job.skills}
                            placeholder="Add Keyword"
                            aria-label="name"
                            aria-describedby="basic-addon1"
                            type="text"
                            name="keywords"
                            value={formData.keywords || ""}
                            onChange={handleCreateChange}
                            required
                          />
                        </>
                      )}
                      <div>
                        {addnewkeyword && (
                          <>
                            <button
                              className="notSelected"
                              onClick={handleKeywordPostData}
                            >
                              &#10003;
                            </button>
                            <button
                              className="notSelected"
                              onClick={(event) => {
                                event.preventDefault();
                                setAddnewkeyword(false);
                              }}
                            >
                              &#10007;
                            </button>
                          </>
                        )}
                        <button
                          className="notSelected"
                          onClick={(event) => {
                            event.preventDefault();
                            setAddnewkeyword(true);
                          }}
                        >
                          Add Keyword
                        </button>
                      </div>
                    </div>
                    <div className="wrapper_input">
                      <div className="jobTitle">Skills: </div>
                      <div id="skill-container">
                        {selectedSkills.map((skill) => (
                          <button
                            key={skill}
                            className={
                              clickedSkills.includes(skill)
                                ? "highlighted"
                                : "nothighlighted"
                            }
                            onClick={(event) => handleSkillClick(event, skill)}
                          >
                            {skill}
                          </button>
                        ))}
                      </div>
                      {addnewskill && (
                        <>
                          <Form.Control
                            className="inputField"
                            // placeholder={job.skills}
                            placeholder="Add Skill"
                            aria-label="name"
                            aria-describedby="basic-addon1"
                            type="text"
                            name="skills"
                            value={formData.skills || ""}
                            onChange={handleCreateChange}
                            required
                          />
                        </>
                      )}
                      <div>
                        {addnewskill && (
                          <>
                            <button
                              className="notSelected"
                              onClick={handleSkillPostData}
                            >
                              &#10003;
                            </button>
                            <button
                              className="notSelected"
                              onClick={(event) => {
                                event.preventDefault();
                                setAddnewskill(false);
                              }}
                            >
                              &#10007;
                            </button>
                          </>
                        )}
                        <button
                          className="notSelected"
                          onClick={(event) => {
                            event.preventDefault();
                            setAddnewskill(true);
                          }}
                        >
                          Add Skill
                        </button>
                      </div>
                    </div>

                    {/* <div className="wrapper_input">
                      <div className="jobTitle">Keywords: </div>
                      <Form.Control
                        className="inputField"
                        placeholder="keywords"
                        aria-label="keywords"
                        aria-describedby="basic-addon1"
                        type="text"
                        name="keywords"
                        value={formData.keywords || ""}
                        onChange={handleCreateChange}
                        required
                      />
                    </div> */}

                    <div className="wrapper_input">
                      <div className="jobTitle">Years Of Experience: </div>
                      <Form.Control
                        className="inputField"
                        placeholder="Years Of Experience"
                        aria-label="name"
                        aria-describedby="basic-addon1"
                        type="text"
                        name="years_of_experience"
                        value={formData.years_of_experience || ""}
                        onChange={handleCreateChange}
                        required
                      />
                    </div>
                    <div className="wrapper_input">
                      <div className="jobTitle">Status: </div>
                      <Form.Select
                        className="inputField"
                        aria-label="Status"
                        aria-describedby="basic-addon1"
                        name="status"
                        value={formData.status || ""}
                        onChange={handleCreateChange}
                        required
                      >
                        <option value="">Select status</option>
                        <option value="active">Active</option>
                        <option value="closed">Closed</option>
                        <option value="draft">Draft</option>
                      </Form.Select>
                    </div>
                    <div className="wrapper_input">
                      <div className="jobTitle">Job Description: </div>
                      <Form.Control
                        className="inputField"
                        as="textarea"
                        placeholder="job_description"
                        aria-label="name"
                        aria-describedby="basic-addon1"
                        type="text"
                        name="job_description"
                        value={formData.job_description || ""}
                        onChange={handleCreateChange}
                        required
                      />
                    </div>
                  </InputGroup>
                  <div className="center">
                    <button className="submitButton" type="submit">
                      Submit
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default Createjob;
